import React from 'react';
import { CheckCircle2, ArrowRight, Loader2 } from 'lucide-react';
import { Button } from './button';

const SuccessScreen = ({ message = "Action completed successfully!", subMessage = "Redirecting you back shortly...", countdown = 3, onAction }) => {
    return (
        <div className="flex flex-col items-center justify-center py-16 px-8 text-center animate-in zoom-in-95 fade-in duration-500 min-h-[400px]">
            <div className="relative mb-10 group">
                <div className="absolute -inset-4 bg-emerald-500 rounded-full blur-2xl opacity-20 group-hover:opacity-40 transition duration-1000 group-hover:duration-200 animate-pulse"></div>
                <div className="relative p-8 rounded-full bg-emerald-100 dark:bg-emerald-950/30 text-emerald-600 dark:text-emerald-400 border-4 border-emerald-50 dark:border-emerald-900/50 shadow-2xl shadow-emerald-500/20 transform hover:scale-110 transition-transform duration-500">
                    <CheckCircle2 className="w-24 h-24 stroke-[1.5]" />
                </div>
            </div>
            
            <h2 className="text-4xl font-black tracking-tight text-slate-800 dark:text-white mb-4 drop-shadow-sm">
                {message}
            </h2>
            
            <p className="text-lg font-bold text-slate-500 dark:text-slate-400 mb-8 max-w-sm flex items-center justify-center gap-3">
                <Loader2 className="w-5 h-5 animate-spin text-emerald-500" />
                {subMessage} 
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-emerald-100 dark:bg-emerald-900/50 text-emerald-600 dark:text-emerald-400 font-extrabold text-sm ml-1 tabular-nums border border-emerald-200/50 shadow-inner">
                    {countdown}
                </span>
            </p>

            <div className="flex gap-4">
               {onAction && (
                <Button 
                    onClick={onAction}
                    variant="ghost" 
                    className="group rounded-2xl h-14 px-8 font-black uppercase tracking-widest text-[#ff6f00] hover:bg-orange-50 transition-all active:scale-95"
                >
                    Return Now <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
               )}
            </div>
        </div>
    );
};

export default SuccessScreen;
